import {charcoal} from '../sass/base/_exports.sass';

export const MiddleAlignIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1, width = 32, height = 32} = props;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        style={{
          fillRule: 'evenodd',
          clipRule: 'evenodd',
        }}
        d="M0.5 1C0.5 0.447715 0.947715 0 1.5 0H15.5C16.0523 0 16.5 0.447715 16.5 1C16.5 1.55228 16.0523 2 15.5 2H1.5C0.947715 2 0.5 1.55228 0.5 1Z"
        fill={color}
      />
      <path
        style={{
          fillRule: 'evenodd',
          clipRule: 'evenodd',
        }}
        d="M4.5 5C4.5 4.44772 4.94772 4 5.5 4H11.5C12.0523 4 12.5 4.44772 12.5 5C12.5 5.55228 12.0523 6 11.5 6H5.5C4.94772 6 4.5 5.55228 4.5 5Z"
        fill={color}
      />
      <path
        style={{
          fillRule: 'evenodd',
          clipRule: 'evenodd',
        }}
        d="M0.5 9C0.5 8.44772 0.947715 8 1.5 8H15.5C16.0523 8 16.5 8.44772 16.5 9C16.5 9.55228 16.0523 10 15.5 10H1.5C0.947715 10 0.5 9.55228 0.5 9Z"
        fill={color}
      />
      <path
        style={{
          fillRule: 'evenodd',
          clipRule: 'evenodd',
        }}
        d="M4.5 13C4.5 12.4477 4.94772 12 5.5 12H11.5C12.0523 12 12.5 12.4477 12.5 13C12.5 13.5523 12.0523 14 11.5 14H5.5C4.94772 14 4.5 13.5523 4.5 13Z"
        fill={color}
      />
    </svg>
  );
};
